<template>
  <div v-if="prototype.name === 'App'">
    <p class="category">Customer Portals</p>
  </div>
  <div v-if="prototype.name === 'Mass Notification'">
    <p class="category">Resident and Family Communications</p>
  </div>
  <div v-if="prototype.name === 'Power Outage'">
    <p class="category">Staff Communications</p>
  </div>
  <div
    class="prototype-tile"
    :class="{ active: isSelected }"
    @click="handleTap"
  >
    <img :src="targetIcon" alt="Target Icon" class="icon" />
    <h4>{{ prototype.name }}</h4>
    <img
      v-if="prototype.items"
      src="@/assets/linear-arrow-right.svg"
      alt="Arrow Icon"
      class="prototype-tile-icon"
      :class="{ 'prototype-tile-icon--expanded': isExpanded }"
    />
    <img
      v-else
      src="@/assets/linear-arrow-right.svg"
      alt="Arrow Icon"
      class="prototype-tile-icon"
    />
  </div>
  <ul v-if="prototype.items && isExpanded" class="prototype-sub-list">
    <li
      v-for="(item, subindex) in prototype.items"
      :key="subindex"
      class="prototype-sub-tile"
      @click="handleSubTap(subindex)"
    >
      <h5 :class="subItemClass(subindex)">{{ item.name }}</h5>
    </li>
  </ul>
</template>

<script lang="ts">
import type { Prototype } from "@/types/prototype";
import {
  INDIVIDUAL_NOTICE_INDEX,
  INVITATIONS_INDEX,
  MASS_NOTIFICATION_INDEX,
} from "@/types/prototype";
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  name: "PrototypeTileComponent",
  props: {
    prototype: {
      type: Object as PropType<Prototype>,
      required: true,
    },
    selectedIndex: {
      type: Number,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      required: true,
    },
    subMassNotifIndex: {
      type: Number,
      required: true,
    },
    subNoticeIndex: {
      type: Number,
      required: true,
    },
    subInvitationIndex: {
      type: Number,
      required: true,
    },
  },
  emits: [
    "select",
    "select-mass-notif-child",
    "select-notice-child",
    "select-invitation-child",
  ],
  computed: {
    targetIcon(): string {
      if (this.prototype.target === "app") {
        return require("@/assets/linear-mobile.svg");
      }
      if (this.prototype.target === "web") {
        return require("@/assets/linear-monitor.svg");
      }
      return require("@/assets/www.svg");
    },
  },
  methods: {
    subItemClass(subindex: number): string {
      if (!this.isSelected) return "";
      const active =
        this.subMassNotifIndex === subindex ||
        this.subNoticeIndex === subindex ||
        this.subInvitationIndex === subindex;
      return active ? "sub-item" : "";
    },
    handleTap(): void {
      if (this.prototype.target === "url") {
        window.open(this.prototype.prototype, "_blank");
        return;
      }
      this.$emit("select");
    },
    handleSubTap(subindex: number): void {
      if (this.selectedIndex === MASS_NOTIFICATION_INDEX) {
        this.$emit("select-mass-notif-child", subindex);
      } else if (this.selectedIndex === INDIVIDUAL_NOTICE_INDEX) {
        this.$emit("select-notice-child", subindex);
      } else if (this.selectedIndex === INVITATIONS_INDEX) {
        this.$emit("select-invitation-child", subindex);
      }
    },
  },
});
</script>

<style scoped>
.prototype-tile {
  padding: 12px;
  border-radius: 8px;
  background: #fff;
  transition: background-color 0.2s ease-in-out;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.16);
  column-gap: 8px;
  margin: 0 0 12px;
  display: flex;
}

.prototype-tile.active {
  background: #f5f5f5;
}

.prototype-tile:not(.active) {
  cursor: pointer;
}

.prototype-tile:not(.active):hover {
  background: #fafafa;
}

.prototype-sub-list {
  list-style: none;
  margin: 0 0 20px;
  padding: 0;
}

.prototype-sub-tile {
  padding: 10px 12px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
  display: block;
  margin: 0 32px 8px;
  cursor: pointer;
}

.prototype-sub-list .prototype-sub-tile:last-child {
  margin-bottom: 0;
}

.prototype-tile-icon {
  flex-shrink: 0;
  transition: transform 0.2s ease-in-out;
}

.prototype-tile-icon--expanded {
  transform: rotate(90deg);
}

.prototype-tile > h4 {
  flex: 1;
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.25;
  text-align: center;
}

.prototype-sub-tile h5 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.25;
  color: #2c3e50;
  text-align: center;
}

.prototype-sub-tile h5.sub-item {
  color: #782256;
}

.category {
  padding: 20px 8px 8px;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  color: #1b365e;
  text-align: left;
}
</style>
